module.exports = __webpack_public_path__ + "static/media/HPIndigo.a505d602.png";